import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteWebhook } from "../../api/apiWebhooks";

export const useDeleteWebhook = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteWebhookMutate, isPending: isDeleting } = useMutation({
        mutationFn: deleteWebhook,
        onSuccess: (res) => {
            toast.success(res?.message || "Webhook deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["webhooks"] });
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || "Error deleting webhook");
        },
    });

    return { deleteWebhookMutate, isDeleting };
};
